export default __webpack_public_path__ + "static/about02-f41d0e4bf4894ac1fa59d68505c511e3.png";